import { render, staticRenderFns } from "./SearchDanger.modal.vue?vue&type=template&id=11015095&"
import script from "./SearchDanger.modal.vue?vue&type=script&lang=js&"
export * from "./SearchDanger.modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports